/**
 * 新OS対応のお知らせページのコンポーネント
 */

import LinkList from "./LinkList";

/**
 * Windows 11対応のお知らせページのProps
 * @param os OS名
 * @param sonfName ソフトウェア名
 * @param items リンクリストの項目
 */
interface WindowsSupportedProps {
  os: string;
  softName: string;
  items: { to: string; text: string }[];
}

/**
 *
 * @param props
 * @returns Windows 新OS対応のお知らせページのJSX Element
 */
export const WindowsSupported: React.FC<WindowsSupportedProps> = (props) => {
  return (
    <div>
      <div className="c-section">
        <h2 className="p-heading-2">{props.os}対応のお知らせ</h2>
        <p className="c-text">
          {props.softName}が、{props.os}で正常に動作することを確認いたしました。
          動作OSの詳細につきましては、以下のページをご覧ください。
        </p>
        <LinkList items={props.items} />
      </div>
    </div>
  );
};
